const navLinks = [
  { id: 'r4', title: 'workouts', route: '/prvn-wedgewood/workouts' },
/*  { id: 'r5', title: 'sponsors', route: '/prvn60openchallenge/sponsors' },*/
  { id: 'r7', title: 'leaderboards', route: '/prvn-wedgewood/leaderboards' },
  { id: 'r6', title: 'faq', route: '/prvn-wedgewood/faq' },
]

export { navLinks }
